export default __webpack_public_path__ + "static/media/WildPlainsMap.542db296.jpg";